export default __webpack_public_path__ + "static/media/food.c93ed504.jpg";